import { useEffect, useState } from 'react';

import { ValidationRules } from '@/utils/validation/types';
import ValidationError from '@/utils/validation/ValidationError';
import Validator from '@/utils/validation/Validator';
import RegExps from 'data/RegExps';

import { EmailValidationHook } from './types';

const useEmailValidation: EmailValidationHook = (email) => {
	const [isEmailValid, setIsEmailValid] = useState(false);
	const [emailValidationMessage, setEmailValidationMessage] = useState<
		string | null
	>(null);

	useEffect(() => {
		const validatedEmail = new Validator(email, 'Email');

		try {
			validatedEmail
				.isNotEmpty()
				.isMatchesRegExp(RegExps.email, 'Please enter a valid email address');

			setIsEmailValid(true);
			setEmailValidationMessage(null);
		} catch (error) {
			if (error instanceof ValidationError) {
				setIsEmailValid(false);

				if (error.rule === ValidationRules.EMPTY) {
					setEmailValidationMessage(null);
				} else {
					setEmailValidationMessage(error.message);
				}
			}
		}
	}, [email]);

	return {
		isEmailValid,
		emailValidationMessage,
	};
};

export default useEmailValidation;
